import { isolateComponent } from '@zapier/style-encapsulation';
import { Icon } from '../../display/Icon';
import { Link } from '../../navigation/Link';
import { Styles } from './Styles';
const ButtonIcon = (props) => (isolateComponent("span", { css: Styles.buttonIcon(props.hasSibling) },
    isolateComponent(Icon, { canAcceptPointerEvents: false, isBlock: true, name: props.iconName, size: props.size })));
const ButtonText = (props) => (isolateComponent("span", { css: Styles.buttonText }, props.children));
const ButtonContent = (props) => {
    return (isolateComponent("span", { css: Styles.buttonContent },
        props.iconBefore && (isolateComponent(ButtonIcon, { hasSibling: !!props.children, iconName: props.iconBefore, size: 24 })),
        isolateComponent(ButtonText, null, props.children)));
};
const getTag = (props) => {
    if (props.presentationOnly) {
        return 'span';
    }
    if (props.htmlFor && !props.disabled) {
        return 'label';
    }
    if (props.href && !props.disabled) {
        return Link;
    }
    return 'button';
};
const defaultProps = {
    disabled: false,
    isFullWidth: false,
    isPill: false,
};
export function BaseButton(_props) {
    const props = Object.assign(Object.assign({}, defaultProps), _props);
    const ButtonTag = getTag(props);
    const isLink = ButtonTag === Link;
    const ariaProps = {
        [`${isLink ? 'ariaLabel' : 'aria-label'}`]: props.ariaLabel,
    };
    return (isolateComponent(ButtonTag, Object.assign({ "aria-controls": props.ariaControls, "aria-describedby": props.ariaDescribedBy, "aria-disabled": props.disabled, "aria-expanded": props.ariaExpanded, "aria-haspopup": props.ariaHaspopup, "aria-hidden": props.ariaHidden }, ariaProps, { color: isLink ? null : undefined, css: Styles.root, "data-color": props.color, "data-icon": props.iconBefore ? 'before' : undefined, "data-full-width": props.isFullWidth ? '' : undefined, "data-pill": props.isPill ? '' : undefined, "data-selected": props.isSelected ? '' : undefined, "data-shadowed": props.hasShadow ? '' : undefined, "data-size": props.size, "data-square": props.isSquare ? '' : undefined, disabled: props.disabled, htmlFor: props.htmlFor, href: isLink ? props.href : undefined, id: props.id, onClick: props.onClick, onKeyDown: props.onKeyDown, rel: isLink ? props.rel : undefined, role: !isLink ? 'button' : undefined, tabIndex: props.tabIndex, target: isLink ? props.target : undefined, type: ButtonTag === 'button' ? props.type : undefined }),
        isolateComponent(ButtonContent, Object.assign({}, props))));
}
//# sourceMappingURL=BaseButton.js.map
// @zapier/design-system@5.26.3 (1a8819ee6)
